import { authHeader, handleResponse } from '../helpers';

const BASE_URL = process.env.REACT_APP_API_URL;

export const twilioService = {
    getAllUsers
};

function getAllUsers() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}/info/twilio-workers`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response.Data || [];
        });
}
